// extracted by mini-css-extract-plugin
export var joinUsSwiper = "index-module--joinUsSwiper--rZ8Qj";
export var swiperBox = "index-module--swiperBox--moZoZ";
export var swiperCard = "index-module--swiperCard--q1P5F";
export var text = "index-module--text--qhPx0";